import axios from "axios";
import { getToken } from "../../../Utlis/UpdateUserState";

const getFuelVendorDocumentRequirements = async () => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}admin/document-requirements/?scope=fuel-vendor`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Fuel vendor document requirements fetch error:", error);
    throw error;
  }
};

const createFuelVendorDocumentRequirement = async (data) => {
  try {
    const token = getToken();

    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}admin/document-requirements/?scope=fuel-vendor`,
      data,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Fuel vendor document requirement create error:", error);
    throw error;
  }
};

const getFuelVendorDocumentRequirementById = async (id) => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}admin/document-requirements/?scope=fuel-vendor&id=${id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Fuel vendor document requirement fetch error:", error);
    throw error;
  }
};

const updateFuelVendorDocumentRequirement = async (id, data) => {
  try {
    const token = getToken();

    const res = await axios.patch(
      `${process.env.REACT_APP_BACKEND_URL}admin/document-requirements/?scope=fuel-vendor&id=${id}`,
      data,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Fuel vendor document requirement update error:", error);
    throw error;
  }
};

const deleteFuelVendorDocumentRequirement = async (id) => {
  try {
    const token = getToken();

    const res = await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}admin/document-requirements/?scope=fuel-vendor&id=${id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Fuel vendor document requirement delete error:", error);
    throw error;
  }
};

export {
  getFuelVendorDocumentRequirements,
  createFuelVendorDocumentRequirement,
  getFuelVendorDocumentRequirementById,
  updateFuelVendorDocumentRequirement,
  deleteFuelVendorDocumentRequirement,
};
